module.exports = __webpack_public_path__ + "static/CoffeeChemistry-64429950e42809f5446570d7595135e7.jpg";